module.exports = __webpack_public_path__ + "static/media/bg_bg.3763664.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/bg_bg.mp3
// module id = HZfI
// module chunks = 1